/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const SessionKind = {
  Standard: "standard",
  Browser: "browser",
  CodingHarness: "coding_harness",
} as const;
export type SessionKind = ClosedEnum<typeof SessionKind>;

/** @internal */
export const SessionKind$inboundSchema: z.ZodNativeEnum<typeof SessionKind> = z
  .nativeEnum(SessionKind);
/** @internal */
export const SessionKind$outboundSchema: z.ZodNativeEnum<typeof SessionKind> =
  SessionKind$inboundSchema;
